<div
  #notificationElement
  fxLayout="column"
  [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
  [ngClass]="{
    'bfx-notification-floating': true,
    'bfx-notification-info': notificationClass == 'bfx-notification-info',
    'bfx-notification-neutral': notificationClass == 'bfx-notification-neutral',
    'bfx-notification-positive': notificationClass == 'bfx-notification-positive',
    'bfx-notification-negative': notificationClass == 'bfx-notification-negative',
    'bfx-notification-soft-cutoff': notificationClass == 'bfx-notification-soft-cutoff',
    'bfx-notification-hard-cutoff': notificationClass == 'bfx-notification-hard-cutoff',
    'desktop': desktop
  }"
>
  <!-- Container with details and buttons -->
  <div class="bfx-notification-container">
    <!-- body of notification with header and details-->
    <div class="bfx-notification-details">
      <!-- Title row with icon, title, timestamp and close button-->
      <div class="bfx-notification-header">
        <div class="bfx-notification-icon">
          <i [class]="iconClass"></i>
        </div>
        <div fxFlex fxFlexAlign="start" class="bfx-notification-title">{{data.title}}</div>
        <div
          class="bfx-notification-date"
          fxFlexAlign="end"
          *ngIf="data.payload && (data.payload.length==1 || data.showTime === true)"
        >
          {{data.time | date:'HH:mm:ss'}}
        </div>
      </div>
      <!-- Main notification body - 2 rows, one for primary body, opne for secondary body -->
      <!-- Multi-row notification body -->
      <!-- body of notification text -->
      <div fxLayout="column" class="bfx-notification-body">
        <div class="bfx-notification-body-primary">
          <div
            class="bfx-notification-body-primary-left"
            title="{{ (data.payload.length > 1) ? data.bodyMultiple : data.body }}"
          >
            {{ (data.payload.length > 1) ? data.bodyMultiple : data.body }}
          </div>
          <div
            class="bfx-notification-body-primary-right"
            *ngIf="data.payload&&data.payload.length==1"
          >
            {{data.bodyType}}
          </div>
        </div>
        <div class="bfx-notification-body-secondary" *ngIf="showSecondaryRow">
          <div class="bfx-notification-body-secondary-left">{{ (showFooter)?data.footer:"" }}</div>
          <div
            class="bfx-notification-body-secondary-right"
            [ngClass]="{'bfx-notify-actionable':data.footerAction && !data.payload[0].as_no_action}"
            (click)="tableAction(data.payload[0])"
            [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
          >
            {{data.payload[0].as_notify_ref}}
          </div>
        </div>
        <div fxFlex fxFlexAlign="start" title="View Connection Monitor" *ngIf="isConnectionMonitor">
          <button
            [class]="buttonClasses"
            (click)="showConnectionMonitor()"
            [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
          >
            CONNECTION MONITOR
          </button>
        </div>
        <div
          fxFlexAlign="end"
          *ngIf="data.payload&&data.payload.length==1 && data.footerAction && !data.payload[0].as_notify_ref"
        >
          <button
            [class]="buttonClasses"
            [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
            (click)="action(data.footerAction)"
          >
            {{(data.payloadIds&&data.payloadIds.length>0) ? (data.payload[0].as_action_id ?
            data.payload[0].as_action_id : data.payload[0].as_notify_ref) : ''}}
          </button>
        </div>
        <!-- View actions for multiple payloads-->
        <div
          fxFlex
          fxFlexAlign="start"
          *ngIf="data.payload.length>1 &&(isAcceptanceNeededType ||isDIType )"
          style="text-align: left"
        >
          <button
            [class]="buttonClasses"
            (click)="showInbox()"
            *ngIf="isAcceptanceNeededType"
            [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
          >
            VIEW INBOX
          </button>
          <button
            [class]="buttonClasses"
            (click)="showIntervention()"
            *ngIf="isDIType"
            [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
          >
            VIEW DEALER INTERVENTION
          </button>
        </div>
      </div>
      <!-- Notification footer with Inline action button-->
      <div fxLayout="row" class="bfx-notification-footer" *ngIf="data.payload?.length>1">
        <!-- Need*ngIf here as ptherwise we get an emptpy div but a double gap-->
        <div
          class="bfx-notification-show-hide-button"
          (click)="showNotificationOrders()"
          [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
        >
          <i [className]="toggleOrdersView" class="ds-cont-cont-typography-icon-xs"> </i>
          <span class="ds-cont-typography-productive-body-sm-emphasised">{{toggleOrdersText}}</span>
        </div>
      </div>
    </div>
    <!-- Right-most column for buttons-->
    <div fxLayout="column" class="bfx-notification-button-container">
      <button
        class="bfx-icon-button-sm"
        [ngClass]="closeButtonClass"
        (click)="close()"
        [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
      >
        <i class="icon-close"></i>
      </button>
      <!-- Action menu button container-->
      <div
        fxLayout="column"
        class="popup-notification__buttons-container"
        [nativeDesktopStyle]="{ '-webkit-app-region' : 'no-drag' }"
      >
        <p-menu
          #menu
          styleClass="bfx-context-menu popup-notification__menu"
          [popup]="true"
          nativeDesktopMenu="notification"
          [nativeDesktopStyle]="{ 'padding' : '0' }"
          appendTo="body"
          placement="top left"
          [model]="menuItems"
        ></p-menu>
        <button
          *ngIf="data.actions&&data.actions.length>0"
          class="bfx-icon-button-sm"
          [ngClass]="actionButtonClass"
          (click)="toggleMenu(menu,$event)"
        >
          <i class="icon-ion_menu_vert"></i>
        </button>
      </div>
    </div>
  </div>

  <div
    class="bfx-notification-extended-container"
    *ngIf="data.payload.length>1  && notificationOpen"
  >
    <!-- TRailing tables -->

    <div
      fxLayout="column"
      class="popup-notification__table"
      *ngIf="!data.payload[0].alternativeTable 
            && !data.payload[0].unsolCanTable"
    >
      <p-table
        [first]="first"
        [value]="data.payload"
        [rows]="pageSize"
        [paginator]="data.payload.length>10"
        [style]="{'width' : '100%'}"
        [totalRecords]="data.payload.length"
      >
        <ng-template pTemplate="body" let-note>
          <tr>
            <td class="bfx-notify-cell-time">{{note.as_notify_time}}</td>
            <td
              [ngClass]="{
              'bfx-notify-cell-instrument':_data.type !== BFXNotificationType.STREAM_OFF,
              'bfx-notify-cell-stream-off-other':_data.type == BFXNotificationType.STREAM_OFF  && _data.subType != BFXNotificationSubType.STREAM_OFF_RATE_STALE && _data.subType != BFXNotificationSubType.STREAM_OFF_STREAM_OFF,
              'bfx-notify-cell-stream-off':_data.type == BFXNotificationType.STREAM_OFF && data.subType == BFXNotificationSubType.STREAM_OFF_STREAM_OFF,
              'bfx-notify-cell-stream-off-stale':_data.type == BFXNotificationType.STREAM_OFF && _data.subType == BFXNotificationSubType.STREAM_OFF_RATE_STALE,
              'bfx-notify-cell-stream-off':_data.type == BFXNotificationType.STREAM_OFF && data.subType == BFXNotificationSubType.STREAM_OFF_STREAM_OFF
              }"
            >
              {{note.as_notify_instrument}}
            </td>
            <td
              *ngIf="_data.type !== BFXNotificationType.STREAM_OFF"
              class="bfx-notify-cell-intent"
            >
              {{note.as_notify_clientIntent}}
            </td>
            <td
              *ngIf="_data.type !== BFXNotificationType.STREAM_OFF"
              [ngClass]="{
              'bfx-notify-cell-body-short':!_data.fullBodyWidth,
              'bfx-notify-cell-body-long':_data.fullBodyWidth
              }"
            >
              {{note.as_notify_body}}
            </td>
            <td
              *ngIf="_data.type !== BFXNotificationType.STREAM_OFF"
              class="bfx-notify-cell-dealttracking"
            >
              {{note.as_notify_dealtTracking}}
            </td>
            <td
              *ngIf="_data.type !== BFXNotificationType.STREAM_OFF"
              class="bfx-notify-cell-order-type"
            >
              {{note.as_notify_requestedOrderType}}
            </td>
            <td
              *ngIf="_data.type !== BFXNotificationType.STREAM_OFF"
              class="bfx-notify-cell-id"
              [ngClass]="{'bfx-notify-actionable':!note.as_no_action && note.as_notify_footerAction}"
            >
              <div (click)="tableAction(note)">{{note.as_notify_ref}}</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>

    <!-- added this table for manual pricing fail -->
    <div fxLayout="row" class="popup-notification__table" *ngIf="data.payload[0].alternativeTable">
      <p-table
        [first]="first"
        [value]="data.payload"
        [rows]="pageSize"
        [paginator]="data.payload.length>10"
        [style]="{'width' : '100%'}"
        [totalRecords]="data.payload.length"
      >
        <ng-template pTemplate="body" let-note>
          <tr>
            <td class="bfx-notify-cell-time">{{note.as_notify_time}}</td>
            <td
              [ngClass]="{
            'bfx-notify-cell-instrument':_data.type !== BFXNotificationType.STREAM_OFF,
            'bfx-notify-cell-stream-off-other':_data.type == BFXNotificationType.STREAM_OFF  && _data.subType != BFXNotificationSubType.STREAM_OFF_RATE_STALE && _data.subType != BFXNotificationSubType.STREAM_OFF_STREAM_OFF,
            'bfx-notify-cell-stream-off':_data.type == BFXNotificationType.STREAM_OFF && data.subType == BFXNotificationSubType.STREAM_OFF_STREAM_OFF,
            'bfx-notify-cell-stream-off-stale':_data.type == BFXNotificationType.STREAM_OFF && _data.subType == BFXNotificationSubType.STREAM_OFF_RATE_STALE,
            'bfx-notify-cell-stream-off':_data.type == BFXNotificationType.STREAM_OFF && data.subType == BFXNotificationSubType.STREAM_OFF_STREAM_OFF
            }"
            >
              {{note.as_notify_instrument}}
            </td>
            <td
              [ngClass]="{
              'bfx-notify-cell-body-long':_true
              }"
            >
              {{note.as_notify_body}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div fxLayout="row" class="popup-notification__table" *ngIf="data.payload[0].unsolCanTable">
      <p-table
        [first]="first"
        [value]="data.payload"
        [rows]="pageSize"
        [paginator]="data.payload.length>10"
        [style]="{'width' : '100%'}"
        [totalRecords]="data.payload.length"
      >
        <ng-template pTemplate="body" let-note>
          <tr>
            <td class="bfx-notify-cell-time">{{note.as_notify_time}}</td>
            <td
              class="bfx-notify-cell-id"
              [ngClass]="{'bfx-notify-actionable':!note.as_no_action && note.as_notify_footerAction}"
            >
              <div (click)="tableAction(note)">{{note.as_notify_ref}}</div>
            </td>
            <td class="bfx-notify-maker-id">{{note.fromMaker}}</td>
            <td class="bfx-notify-migrated">{{note.migragtedStr}}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
  <div class="bfx-pagination-floating" *ngIf="notificationOpen && pageCount > 1">
    <button
      [disabled]="pageNo == 1"
      class="bfx-icon-button-sm"
      [ngClass]="actionButtonClass"
      (click)="previousPage()"
    >
      <i class="icon-ion_chevron_left"></i>
    </button>
    {{pageNo}}/{{pageCount}}
    <button
      [disabled]="pageNo == pageCount"
      class="bfx-icon-button-sm"
      [ngClass]="actionButtonClass"
      (click)="nextPage()"
    >
      <i class="icon-ion_chevron_right"></i>
    </button>
  </div>
  <!-- Final BCSDX icon for desktop notifications-->
  <div *ngIf="desktop">
    <div class="bfx-notification-logo-container">
      <bfx-logo-svg></bfx-logo-svg>
    </div>
  </div>
</div>
